const React = require('react');
const upperFirst = require('mn-utils/upperFirst');

import {
  openPopupInfo,
} from '../../../../../emitters/popup';

const {pushLocation} = require('../../../../../router');
const {apiV2SendTransactionCallback} = require('../../../../../api/merchant/transactions');

const {LINK_PAYMENT_DETAILS} = require('../../../../../constants/links');
const paymentTypes = require('../../../../../constants/paymentTypes');

const MenuForItem = require('../../../../dumb/Menu/ForItem');
const {
  DisplayIdMerchant,
  DisplayDataMerchant,
  DisplayDateTimeMerchant,
  DisplayAmountFCMerchant
} = require('../../../../dumb/DisplayData');
const {DisplayStatusTrx} = require('../../../../dumb/StatusDisplay');

module.exports = (props) => {
  const data = props.data || {};

  const {
    id,
    app_name: appUrl,
    kind,
    lifeflow: status,
    payment_method,
    customer_email,
    target_asset: cc_code,
    target_amount: crypto_amount,
    source_asset: fiat_code,
    source_amount: fiat_amount,
    client_quote_id,
    created_at,
  } = data;

  const paymentMethodName = paymentTypes[payment_method];

  return (
    <div
      className={`w layoutRow fhaS fvaC h114 rlv lh fw7 f12 c2 tc lts0em
           ph20 (ph10|w1/6)>1 bgF6F6F6.even` + (props.index % 2 === 1 ? ' even' : '')}
    >
      <div className="tl pl25@d2 lh130%">
        <div>
          {paymentMethodName
            ? paymentMethodName
            : upperFirst(payment_method || '').replace('_', ' ')
          }
        </div>
        <DisplayDataMerchant className="fhaS mt3 fw4 c717275">
          {customer_email}
        </DisplayDataMerchant>
      </div>
      <div>
        <DisplayDataMerchant>
          {appUrl}
        </DisplayDataMerchant>
      </div>
      <div>
        <DisplayIdMerchant>
          {client_quote_id}
        </DisplayIdMerchant>
      </div>
      <div>
        <DisplayDateTimeMerchant
          date={created_at}
        />
      </div>
      <div>
        <DisplayAmountFCMerchant
          fiat={{amount: fiat_amount, symbol: fiat_code}}
          crypto={{amount: crypto_amount, symbol: cc_code}}
        />
      </div>
      <div>
        <DisplayStatusTrx status={status} />
        {kind !== 'chargeback' && (
          <MenuForItem
            items={[
              {
                name: 'Details', onClick() {
                  pushLocation({
                    path: `${LINK_PAYMENT_DETAILS}/${id}`,
                  });
                },
              },
              status === 'completed' && {
                name: 'Send callback', onClick() {
                  apiV2SendTransactionCallback(id).then(() => openPopupInfo(['We\'ve sent you a callback']));
                },
              }
            ].filter((el) => el)}
          />
        )}
      </div>
    </div>
  );
};
